import React from 'react';
import FileDownloadIcon from '../../../../icons/FileDownloadIcon';
import { Media } from '@twilio/conversations';
import { styled } from '@mui/material/styles';

const MessageContainer = styled('div')({
  display: 'flex',
  padding: '0.9em 1.5em',
  margin: '0.6em 0',
  border: '2px solid #e4e7e9',
  borderRadius: '4px',
  cursor: 'pointer',
});

const IconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const MediaInfo = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: '1.5em',
  minWidth: 0,
  '& p': {
    margin: 0,
    fontSize: '12px',
  },
});

const Filename = styled('p')({
  fontWeight: 700,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const Size = styled('p')({
  fontWeight: 400,
});

interface MediaMessageProps {
  media: Media;
}

export function formatFileSize(bytes: number, suffixIndex = 0): string {
  const suffixes = ['bytes', 'KB', 'MB', 'GB'];
  if (bytes < 1000) return +bytes.toFixed(2) + ' ' + suffixes[suffixIndex];
  return formatFileSize(bytes / 1024, suffixIndex + 1);
}

export default function FileMessage({ media }: MediaMessageProps) {
  const handleClick = () => {
    media.getContentTemporaryUrl().then(url => {
      if (!url) return;
      const anchorEl = document.createElement('a');

      anchorEl.href = url;
      anchorEl.target = '_blank';
      anchorEl.rel = 'noopener';

      // setTimeout is needed in order to open files in iOS Safari.
      setTimeout(() => {
        anchorEl.click();
      });
    });
  };

  return (
    <MessageContainer onClick={handleClick}>
      <IconContainer>
        <FileDownloadIcon />
      </IconContainer>
      <MediaInfo>
        <Filename>{media.filename}</Filename>
        <Size>{formatFileSize(media.size)} - Click to open</Size>
      </MediaInfo>
    </MessageContainer>
  );
}
